import React, { MouseEventHandler } from "react"
import { Box } from "@mui/material"
import styles from "./ButtonWithLicence.module.scss"

interface Props {
  color: string
  text: string
}
/**
 * 免許証画像付きボタン
 * @param {string} color - ボタンの色
 * @param {string} text - ボタン上に表示する文言
 */
const ButtonWithLicence = ({ color, text }: Props) => {
  return (
    <>
      <span className={styles.buttonWrapper}>
        <img alt={color} src={`./licence_${color}.png`} />
        <br />
        <span className={styles.text}>{text}</span>
      </span>
    </>
  )
}
export default ButtonWithLicence
